import AreasModal from './AreasModal'
export default AreasModal
